var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-play"},[(_vm.m3u8)?_c('video',{ref:"video",staticClass:"full-height full-width",attrs:{"controls":"","id":"video"}}):_c('video',{attrs:{"src":_vm.url,"autoplay":"","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }